
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class PaymentRequestWriterService {

   public static checkAndUpdateStatus(
           axiosInstance: AxiosInstance, input: ServerData.PaymentRequestWebWriter.CheckAndUpdateStatus$Input,
           f: (output: ServerData.PaymentRequestWebWriter.CheckAndUpdateStatus$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'paymentapi/paymentrequest/check-and-update-status',
            input.toJson()
        ).then((response) => ServerData.PaymentRequestWebWriter.CheckAndUpdateStatus$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static requestFundSplit(
           axiosInstance: AxiosInstance, input: ServerData.PaymentRequestWebWriter.RequestFundSplit$Input,
           f: (output: string) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'paymentapi/paymentrequest/request-fund-split',
            input.toJson()
        ).then((response) => response.data as string)
       .then((output) => f(output))
       .catch(theEh);
   }


   public static updateFundSplitStatus(
           axiosInstance: AxiosInstance, input: ServerData.PaymentRequestWebWriter.UpdateFundSplitStatus$Input,
           f: (output: string) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'paymentapi/paymentrequest/update-fund-split-status',
            input.toJson()
        ).then((response) => response.data as string)
       .then((output) => f(output))
       .catch(theEh);
   }


   public static cancel(
           axiosInstance: AxiosInstance, input: ServerData.PaymentRequestWebWriter.Cancel$Input,
           f: (output: string) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'paymentapi/paymentrequest/cancel',
            input.toJson()
        ).then((response) => response.data as string)
       .then((output) => f(output))
       .catch(theEh);
   }


}

